module.exports = __webpack_public_path__ + "static/media/step-4.993f5a57.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BuyForMe/icons/step-4.svg
 ** module id = 878
 ** module chunks = 0
 **/